import React from "react";
import { isPlayEnv } from "helpers/helper";
import "./PlayBorder.scss";

const PlayBorder = () => {
  return (
    <>
      {isPlayEnv() && (
        <div className="play-env-container">
          <div className="play-env-container__banner">PLAY</div>
        </div>
      )}
    </>
  );
};

export default PlayBorder;
